module.exports = __webpack_public_path__ + "img/pack_confort.40dd9856.png";